import { useZoneEditorStore } from "../../state/zone-editor-store.js";

export function ZoneEditorPageNav() {
  const {
    pages,
    currentPageNumber,
    setCurrentPage,
    updateAnchorText,
    zoneMappings,
    pageMatchingStrategy,
  } = useZoneEditorStore();

  const showAnchors = pageMatchingStrategy === "anchor";

  const getZoneCountForPage = (pageNumber: number) =>
    zoneMappings.filter((zm) => zm.zone?.pageNumber === pageNumber).length;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 8,
        padding: "8px 12px",
        borderTop: "1px solid #e5e7eb",
        background: "#f9fafb",
        overflowX: "auto",
        flexShrink: 0,
        minHeight: showAnchors ? 120 : 90,
      }}
    >
      {pages.map((page) => {
        const isActive = page.pageNumber === currentPageNumber;
        const zoneCount = getZoneCountForPage(page.pageNumber);

        return (
          <div
            key={page.pageNumber}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
              flexShrink: 0,
            }}
          >
            {/* Thumbnail */}
            <div style={{ position: "relative" }}>
              <button
                onClick={() => setCurrentPage(page.pageNumber)}
                style={{
                  padding: 0,
                  border: `2px solid ${isActive ? "#ea580c" : "#d1d5db"}`,
                  borderRadius: 4,
                  cursor: "pointer",
                  background: "#fff",
                  display: "block",
                  overflow: "hidden",
                  width: 56,
                  height: 72,
                  transition: "border-color 0.1s",
                }}
                title={`Page ${page.pageNumber}`}
              >
                {page.imageUrl ? (
                  <img
                    src={page.imageUrl}
                    alt={`Page ${page.pageNumber}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                    draggable={false}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      background: "#f3f4f6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 11,
                      color: "#9ca3af",
                    }}
                  >
                    {page.pageNumber}
                  </div>
                )}
              </button>

              {/* Zone count badge */}
              {zoneCount > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: "#ea580c",
                    color: "#fff",
                    fontSize: 10,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #fff",
                    pointerEvents: "none",
                  }}
                >
                  {zoneCount}
                </div>
              )}
            </div>

            {/* Page number label */}
            <span
              style={{
                fontSize: 10,
                color: isActive ? "#ea580c" : "#6b7280",
                fontWeight: isActive ? 600 : 400,
              }}
            >
              {page.pageNumber}
            </span>

            {/* Anchor text input (only shown for anchor strategy) */}
            {showAnchors && (
              <input
                type="text"
                value={page.anchorText ?? ""}
                onChange={(e) => updateAnchorText(page.pageNumber, e.target.value)}
                placeholder="Anchor…"
                title="Anchor text for page matching"
                style={{
                  width: 56,
                  fontSize: 10,
                  padding: "2px 4px",
                  border: `1px solid ${page.anchorDirty ? "#ea580c" : "#d1d5db"}`,
                  borderRadius: 3,
                  color: "#374151",
                  background: "#fff",
                  textAlign: "center",
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
